import script from "./SearchResultSkeleton.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchResultSkeleton.vue?vue&type=script&lang=ts&setup=true"

import "./SearchResultSkeleton.vue?vue&type=style&index=0&id=8230d074&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8230d074"]])

export default __exports__